import { createSlice } from '@reduxjs/toolkit';
import getPathologyAIStudies from '@custom/rtk-apis/microscopy/getPathologyAIStudies';

const pathologyAIStudiesSlice = createSlice({
  name: 'pathologyAIStudies',
  initialState: {
    status: '',
    result: [] as any[],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPathologyAIStudies.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPathologyAIStudies.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload?.status || '';
        state.result = payload?.result || [];
      })
      .addCase(getPathologyAIStudies.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default pathologyAIStudiesSlice.reducer;
